import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// Single-click calc guide shared by the landing chart and every drill-down tile (no hover tooltip — 17116 round 2)
const CalcGuideDialog = ({ open, onClose, title, sections }) => (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ pr: 6 }}>
            {title}
            <IconButton
                onClick={onClose}
                aria-label="Close"
                sx={{ position: 'absolute', right: 8, top: 8 }}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </DialogTitle>
        <DialogContent dividers>
            {sections.map((section) => (
                <Typography key={section.lead} sx={{ fontSize: '13px', mb: 1.5 }}>
                    <b><i>{section.lead}</i></b> {section.text}
                </Typography>
            ))}
        </DialogContent>
    </Dialog>
);

export default CalcGuideDialog;
